<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import Button from './../../../inputs/Button/v1/Button.svelte';

    const dispatch = createEventDispatcher();

    /** @type {'info'|'warning'|'loading'|'success'} */
    export let type = 'info';
    /** @type {boolean} */
    export let visible = false;
    /** @type {string} */
    export let text = null;
    /** @type {string} */
    export let html = null;
    /** @type {string} */
    export let close = null;
    /** @type {boolean} */
    export let closable = true;
    /** @type {'icon'|'secondary'} */
    export let closeButtonType = 'icon';
    /** @type {string} */
    export let infoText = 'information';
    /** @type {string} */
    export let warningText = 'warning';
    /** @type {string} */
    export let loadingText = 'loading';
    /** @type {string} */
    export let successText = 'success';

    /** internal */
    let showMessage = false;

    $: closeText =
        close ||
        !closable ||
        console.warn('Banner close text is required but not included!');

    let ariaLive = '';

    $: {
        ariaLive = { info: 'polite', warning: 'assertive' }[type] || 'polite';
    }

    let role = '';

    $: {
        role = { info: 'status', warning: 'alert' }[type] || 'status';
    }

    $: roleText = { info: infoText, warning: warningText, loading: loadingText, success: successText }[type];

    $: onMount(() => {
        if (visible) {
            // Render the live-area container first, then show the message inside on the next frame
            setTimeout(() => {
                showMessage = visible;
            }, 200);
        }
    });

    $: {
        // If the banner has been made visible show the message on the next frame
        if (visible) {
            setTimeout(() => {
                showMessage = true;
            }, 100);
        } else {
            showMessage = false;
        }
    }

    function hide(event) {
        visible = false;
        dispatch('hidden', { event });
    }
</script>

{#if visible}
    <div class="prom-banner prom-banner--{type}">
        <div class="prom-banner__icon" aria-hidden="true"></div>
        <span
            class="prom-banner__message"
            aria-live="{ariaLive}"
            role="{role}"
            aria-atomic="true">
            {#if showMessage}
                <span class="screen-reader">{roleText}</span>
                {#if text} {text} {/if}
                {#if html} {@html html} {/if}
                <slot />
            {/if}
        </span>
        {#if closable}
            {#if closeButtonType === 'icon'}
                <button type="button" class="prom-banner__close" on:click="{hide}">
                    <span class="screen-reader">{closeText}</span>
                </button>
            {:else}
                <Button type="{closeButtonType}" htmlType="button" text="{closeText}" on:click="{hide}"></Button>
            {/if}
        {/if}
    </div>
{/if}
